module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "blue",
      "data-image": "../assets/img/sidebar-5.jpg"
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text logo-mini",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('a', {
    staticClass: "simple-text logo-normal",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("RAEFTON")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/raw_templates/t_dashboard"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-delivery-fast"
  }), _vm._v(" "), _c('p', [_vm._v("RFQs")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item active "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/raw_templates/t_createrfq"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("CREATE RFQ")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/raw_templates/t_contacts"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("CONTACTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(/static/img/sidebar-5.jpg)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg "
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-fill btn-round btn-icon d-none d-lg-block",
    attrs: {
      "id": "minimizeSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v visible-on-sidebar-regular"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-navicon visible-on-sidebar-mini"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#pablo"
    }
  }, [_vm._v("Create RFQ")])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "aria-controls": "navigation-index",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("RFQ Customer Details")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Customer")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v("Brian G. Baldree")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v("86 Edwin Street"), _c('br'), _vm._v("Kitchener, Ontario"), _c('br'), _vm._v("K0A 2N0"), _c('br'), _vm._v("Canada")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Terms")]), _c('br'), _vm._v("EXW Ex-Works")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Due Date")]), _c('br'), _vm._v("11/01/2018")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Shipper")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v("Katherine C. Hinkle")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v("88 Martin St"), _c('br'), _vm._v("Kitchener, Ontario"), _c('br'), _vm._v("K0A 2N0"), _c('br'), _vm._v("Canada")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Appointment")]), _c('br'), _vm._v("No")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Pick Up Date")]), _c('br'), _vm._v("11/01/2018 12:00")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Consignee")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v("Brandy Kersey")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v("99 James Street"), _c('br'), _vm._v("Kitchener, Ontario"), _c('br'), _vm._v("K0A 2N0"), _c('br'), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Appointment")]), _c('br'), _vm._v("No")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("COD")]), _c('br'), _vm._v("No")])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Delivery")]), _c('br'), _vm._v("11/01/2018 12:00")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3"
  }, [_c('h5', [_vm._v("Truck")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Trailer Type")]), _c('br'), _vm._v("Dry Van")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Suspension Type")]), _c('br'), _vm._v("Spring")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Temperature Control")]), _c('br'), _vm._v("Reefer Fresh")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lift Gate")]), _c('br'), _vm._v("Yes")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Driver Assist")]), _c('br'), _vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Mode")]), _c('br'), _vm._v("FTL")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Service")]), _c('br'), _vm._v("Overnight")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Dunnage Required")]), _c('br'), _vm._v("1.5 l/ cu-ft")])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Special Instructions")]), _c('br'), _vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsa vitae repellat hic a autem quam maxime laudantium quisquam. Itaque soluta rem veritatis, natus velit eum dolorem quos recusandae! Nam, eum.")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Assignees")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Due Date")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("John Valence")]), _vm._v(" "), _c('td', [_vm._v("11/02/2018")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-xs btn-danger"
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "assignee_name"
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "datetimepicker",
      "type": "text"
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-xs btn-success"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Quotes")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Quote Author")]), _vm._v(" "), _c('th', [_vm._v("Cost")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("John Valence")]), _vm._v(" "), _c('td', [_vm._v("N/A")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-xs btn-success"
  }, [_vm._v("Finish Quote")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-block text-center"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-xs btn-primary"
  }, [_vm._v("Add Quote")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card data-tables"
  }, [_c('div', {
    staticClass: "card-body table-no-bordered dataTable dtr-inline table-full-width"
  }, [_c('div', {
    staticClass: "toolbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "fresh-datatables"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "disabled-sorting"
  }), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Length")]), _vm._v(" "), _c('th', [_vm._v("Width")]), _vm._v(" "), _c('th', [_vm._v("Height")]), _vm._v(" "), _c('th', [_vm._v("Stackable")]), _vm._v(" "), _c('th', [_vm._v("Units")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("#1")]), _vm._v(" "), _c('td', [_vm._v("1 item in inches")]), _vm._v(" "), _c('td', [_vm._v("imperial type walker")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("304.8")]), _vm._v(" "), _c('td', [_vm._v("304.8")]), _vm._v(" "), _c('td', [_vm._v("304.8")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("mm/g")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("#2")]), _vm._v(" "), _c('td', [_vm._v("1 item 900 grams")]), _vm._v(" "), _c('td', [_vm._v("metric type x-wing")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("mm/g")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])])]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', [_c('p', {
    staticClass: "copyright text-center"
  }, [_vm._v("\n            © 2018 Raefton\n          ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c048a4f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/raw_templates/t_viewrfq.vue
// module id = 728
// module chunks = 0